import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

export type ToTimezoneMode = 'dateTime' | 'dateOnly' | 'timeOnly';

/**
 * Converts a UTC date string to a local datetime string in the given timezone.
 *
 * Usage:
 *   {{ dateString | toTimezone: pickupGmt : 'dateTime' }}
 *   {{ dateString | toTimezone: pickupGmt : 'dateOnly' }}
 *   {{ dateString | toTimezone: pickupGmt : 'timeOnly' }}
 */
@Pipe({
  name: 'toTimezone',
  pure: true,
})
export class ToTimezonePipe implements PipeTransform {
  transform(value: string | Date | null | undefined, timezone: string, mode: ToTimezoneMode = 'dateTime'): string {
    if (!value) {
      return '';
    }
    if (!timezone) {
      timezone = 'UTC';
    }

    const m = moment.tz(value, timezone);
    if (!m.isValid()) {
      return '';
    }

    switch (mode) {
      case 'dateOnly':
        return m.format('DD/MM/YYYY');
      case 'timeOnly':
        return m.format('HH:mm');
      case 'dateTime':
      default:
        return m.format('DD/MM/YYYY HH:mm');
    }
  }
}
